import CustomDialog from "../utils/dialog/customDialog";
import { useScheduleTagging } from "./TaxAdjustment/hooks/useScheduleTagging";
import { getScheduleDocumentType } from "./TaxAdjustment/services/scheduleTaggingService";

const RemoveTaggingDialog = ({
  open,
  row,
  source,
  onClose,
  onDone,
  handleError,
}) => {
  const { unTagSchedule } = useScheduleTagging();
  return (
    <CustomDialog
      type='error'
      open={open}
      onClose={() => onClose()}
      onConfirm={async () => {
        try {
          if (row?.schedule) {
            await unTagSchedule(
              source,
              row.row_id,
              getScheduleDocumentType(row.schedule.scheduleType)
            );
          }
          await onDone(row);
        } catch (error) {
          handleError(
            "The adjustment could not be updated due to an unexpected error. Please try again later."
          );
        }
      }}
      title={`Removing ${row?.name || "this row"}?`}
      description={
        row?.schedule
          ? "Changing this row will affect the selected schedule. Do you want to proceed?"
          : "You are not able to recover back your row after removing it. Do you want to proceed?"
      }
    />
  );
};

export default RemoveTaggingDialog;
